module.exports = __webpack_public_path__ + "img/activity_bj.294b356d.png";